/* v34 (UI/UX T1): the one-tap [data-tg-add] listener that lived here is gone. assets/tailgater-add.js (every page) already
   handles [data-tg-add] (multi-id, events, drawer); both listening meant one tap = two POSTs = quantity 2 and no drawer. */
/* Add to cart, while it adds (fresh-eyes 2026-10-29: the pale disabled button read as broken for 3-5 s). The theme
   disables the button during the request; mark it "Adding…" from submit until the cart updates or 10 s pass. */
(function () {
  if (window.tgAdding) return;
  window.tgAdding = true;
  var BTN = '.add-to-cart-button, .sticky-add-to-cart__button';
  function clear() {
    document.querySelectorAll('[data-tg-adding]').forEach(function (b) {
      b.removeAttribute('data-tg-adding');
      b.removeAttribute('aria-busy');
    });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest(BTN);
    if (!b || b.disabled) return;
    b.setAttribute('data-tg-adding', '');
    b.setAttribute('aria-busy', 'true');
    setTimeout(clear, 10000);
  }, true);
  document.addEventListener('cart:update', clear);
  document.addEventListener('cart:error', clear);
})();
